import React from 'react'

const GhPackagaes = () => {
  return (
    <div className='gh-packages'>
      Implementation for fetching packages created by an user is in development phase.
    </div>
  )
}

export default GhPackagaes